import React from 'react';
import { Button, Card, Col, Row, Typography, Tooltip } from 'antd';
import { userCan } from '@/utils/authority';
const { Title } = Typography;
/**
 * @description - This component renders when no playbook exists 
 * for current signature or risk.
 * @param {String} description - Helper text for playbooks 
 * @callback onCreate - Handler for Create Playbook button
 * @returns {JSX}
 */
function CreatePlaybook({ description, onCreate }) {

    return (
      <Card bordered={false}>

        <Row>
          <Col>
            <Title level={3}>Automate Remediation</Title>
          </Col>
        </Row>

        <Row className="mb-3">

          <Col>
            {description}
          </Col>

        </Row>

        <Row>
          <Col>
            <Tooltip
              title={
                            userCan('create-playbook')
                                ? 'Create new playbook'
                                : "You don't have permission to create new playbook."
                        }
            >
              <Button
                disabled={!userCan('create-playbook')}
                type="primary"
                onClick={userCan('create-playbook', onCreate)}
              >
                            Create Playbook
              </Button>
            </Tooltip>
          </Col>
        </Row>

      </Card>
    )
}

export default CreatePlaybook
